define('TescoMobile_Esim/js/view/catalog/product/sim-preference',['uiComponent', 'ko', 'TescoMobile_Catalog/js/view/deal-device', 'TescoMobile_Catalog/js/view/contract-type-switcher'], function (Component, ko) {
  'use strict';

  return Component.extend({
    defaults: {
      selectedSku: null,
      selectedContractType: null,
      skuProvider: 'tm-deal-device',
      contractTypeProvider: 'contract_type_switcher',
      imports: {
        selectedSku: '${ $.skuProvider }:deviceSku',
        selectedContractType: '${ $.contractTypeProvider }:contractType'
      },
      modules: {
        dealDevice: '${ $.skuProvider }'
      }
    },
    initialize: function () {
      this._super();
      this.esimPreferenceVisible = ko.computed(function () {
        return this.hasEsimPreference(this.selectedSku()) && this.isPayMonthly(this.selectedContractType());
      }, this);
      this.visible = ko.computed(function () {
        return this.esimPreferenceVisible();
      }, this);
      this.simPreference = ko.computed(function () {
        if (this.esimPreferenceVisible()) {
          return 'eSimOnly';
        } else {
          return '';
        }
      }, this);
    },
    initObservable: function () {
      this._super().observe(['selectedSku', 'selectedContractType']);
      return this;
    },
    hasEsimPreference: function (sku) {
      if (!sku) {
        return false;
      }
      return this.dealDevice().optionMap.device.options.filter(option => option.sku === sku).some(option => option.sim_preference === 'eSimOnly');
    },
    isPayMonthly: function (contractType) {
      if (!contractType) {
        return false;
      }
      return contractType === 'paym';
    }
  });
});

